import { SOFTWARE } from '../constant/actionTypes';

const getSoftwareData = (state, action) => {
  switch (action.type) {
    case SOFTWARE.DATA.INITIATE:
      return { isFetching: true };
    case SOFTWARE.DATA.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.DATA.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwareData;
